// Helpers
const getSingularOrPluralPlans = plans => {
  return (plans.length > 1) ? 'these plans' : 'this plan';
};

const getPlanNames = plans => plans.map(plan => plan.planLegalName).join(', ');

// FTD Text & getters
const tiaaVariableAnnuityFTD = 'Limit 1 per quarter. Limitations may apply to any transaction resulting in a balance > $150,000.';

const getCrefVariableAnnuityFTD = (numberOfDays, daysBlocked) => `If you transfer out of this Account, transfer in, and subsequently transfer out within ${numberOfDays} calendar days, future transfers into this Account may be restricted for ${daysBlocked} calendar days. Please see the prospectus for details of the Account's frequent trader policy.`;

const getMutualFundFTD = numberOfDays => `You cannot exchange into the fund within ${numberOfDays} calendar days of exchanging out of the fund. For details on frequent trading policy, review fund's prospectus.`;

const mutualFundFTD = 'You cannot exchange into the fund within 30 calendar days of exchanging out of the fund. For details on frequent trading policy, review fund\'s prospectus.';

const getContributionDisallowedPlansFTD = plans => `Contributions not allowed for this investment within ${getSingularOrPluralPlans(plans)} ${getPlanNames(plans)}`;

const getTransferDisallowedPlansFTD = plans => `Transfers not allowed for this investment within ${getSingularOrPluralPlans(plans)} ${getPlanNames(plans)}`;

const contributionDisallowedPlanFTD = 'Contributions not allowed';
const transfersDisallowedPlanFTD = 'Transfers not allowed';
const contributionAndTransferDisallowedPlanFTD = 'Contributions & Transfers in not allowed';

const frequentTraderDisclosures = {
  fund: {
    tiaaVariableAnnuityFTD,
    getCrefVariableAnnuityFTD,
    getMutualFundFTD,
    mutualFundFTD
  },
  plan: {
    getContributionDisallowedPlansFTD,
    getTransferDisallowedPlansFTD,
    contributionAndTransferDisallowedPlanFTD,
    contributionDisallowedPlanFTD,
    transfersDisallowedPlanFTD
  }
};

export default frequentTraderDisclosures;
